import { render, staticRenderFns } from "./newCount2.vue?vue&type=template&id=08d80b4e&scoped=true&"
import script from "./newCount2.vue?vue&type=script&lang=js&"
export * from "./newCount2.vue?vue&type=script&lang=js&"
import style0 from "./newCount2.vue?vue&type=style&index=0&id=08d80b4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d80b4e",
  null
  
)

export default component.exports